import React from "react";
import {
  Sun,
  CloudSun,
  Cloud,
  CloudFog,
  CloudDrizzle,
  CloudRain,
  CloudSnow,
  CloudLightning,
} from "lucide-react";
import { getWeatherMeta } from "../services/weatherService";

/**
 * Composant icône météo dynamique basé sur le code WMO Open-Meteo
 */
export default function WeatherIcon({ code, className = "w-4 h-4", showColor = true }) {
  const meta = getWeatherMeta(code);
  const colorClass = showColor ? meta.color : "";

  switch (meta.icon) {
    case "Sun":
      return <Sun className={`${className} ${colorClass}`} />;
    case "CloudSun":
      return <CloudSun className={`${className} ${colorClass}`} />;
    case "Cloud":
      return <Cloud className={`${className} ${colorClass}`} />;
    case "CloudFog":
      return <CloudFog className={`${className} ${colorClass}`} />;
    case "CloudDrizzle":
      return <CloudDrizzle className={`${className} ${colorClass}`} />;
    case "CloudRain":
      return <CloudRain className={`${className} ${colorClass}`} />;
    case "CloudSnow":
      return <CloudSnow className={`${className} ${colorClass}`} />;
    case "CloudLightning":
      return <CloudLightning className={`${className} ${colorClass}`} />;
    default:
      return <CloudSun className={`${className} ${colorClass}`} />;
  }
}
